import { z } from 'zod';

const optionalText = (max, message) => z.string().trim().max(max, message).optional().or(z.literal(''));

const baseFields = {
  name: z.string().trim().min(1, '姓名不能為空').max(100, '姓名最多 100 字'),
  chnName: optionalText(100, '中文名最多 100 字'),
  engName: optionalText(100, '英文名最多 100 字'),
  workEmail: z.string().trim().max(254, '工作信箱最多 254 字')
    .email('工作信箱格式不正確').optional().or(z.literal('')),
  remark: optionalText(500, '備註最多 500 字'),
};

// 欄位順序＝錯誤摘要順序，與畫面由上而下一致
export const userCreateSchema = z.object({
  accountNo: z.string().trim().min(1, '帳號編號不能為空').max(50, '帳號編號最多 50 字'),
  account: z.string().trim().min(1, '登入帳號不能為空').max(50, '登入帳號最多 50 字'),
  name: baseFields.name,
  password: z.string().min(1, '密碼不能為空'),
  ...baseFields,
});

export const userEditSchema = z.object({
  accountNo: z.string().optional(),
  account: z.string().optional(),
  name: baseFields.name,
  status: z.enum(['ACTIVE', 'INACTIVE'], { message: '請選擇狀態' }),
  ...baseFields,
});

export const USER_FIELD_LABELS = {
  accountNo: '帳號編號',
  account: '登入帳號',
  name: '姓名',
  chnName: '中文名',
  engName: '英文名',
  workEmail: '工作信箱',
  password: '密碼',
  status: '狀態',
  remark: '備註',
};
